import user from "../../../../../js/user.js";
import { auth } from '@/app/auth';

export default () => {
  // Buscamos todos los iframes
  const divs = document.getElementsByClassName('dailymotion-cpe');

  if (divs.length > 0) {
    for (let div of divs) {

      // Dependiendo si el usuario está logado o no, añadimos partner a la url o no
      if (user.isLogged && user.isPartner) {
        div.setAttribute('ads-params','partners');
        // Dependiendo si el usuario está logado o no, añadimos partner a la url o no
        if (user.isLogged && user.isPartner || window.appInfo.partner === true) {
          div.setAttribute('ads-params', 'partners');
        }
      }
    }

    // Delete following line if #76981 Validated
    (function(w,d,s,u,n,i,f,g,e,c){w.WDMObject=n;w[n]=w[n]||function(){(w[n].q=w[n].q||[]).push(arguments);};w[n].l=1*new Date();w[n].i=i;w[n].f=f;w[n].g=g;e=d.createElement(s);e.async=1;e.src=u;c=d.getElementsByTagName(s)[0];c.parentNode.insertBefore(e,c);})(window,document,"script","//api.dmcdn.net/pxl/cpe/client.min.js","cpe","5ea55b57d92714c4bf5045aa",{scroll_to_pause: true})
  }
}
